import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { User } from './user'

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>
  public currentUser: Observable<User>

  constructor() {
    this.currentUserSubject = new BehaviorSubject<User>(null)
    this.currentUser = this.currentUserSubject.asObservable()
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value
  }

  login(username: string, password: string) {
    const user = new User()
    user.authdata = window.btoa(unescape(encodeURIComponent(username + ':' + password)))
    this.currentUserSubject.next(user)
    return user
  }

  logout() {
    // remove user from local storage to log user out
    this.currentUserSubject.next(null)
  }
}
